@use '../../styling/colors.scss' as *;

.CardTable {
  border-radius: 4px;
  border: 1px solid $theme-color-borders;
  background: $theme-color-sub-background;
  padding: 15px 20px 60px;
  height: 100%;
  overflow-y: auto;
  box-sizing: border-box;
}
